import module from 'recursoshumanos/module.js'
import template from './template.html'
import { isDate, orderBy } from 'lodash'
import * as moment from 'moment'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase().trim()
const unificarPeriodo = (fechaInicial, fechaFinal) => {
  let inicial = moment(fechaInicial).format('YYYY,MMMM,D').split(',')
  const final = moment(fechaFinal).format('YYYY,MMMM,D').split(',')
  const coincide = {
    periodo: inicial[0] === final[0],
    mes: inicial[1] === final[1],
    dia: inicial[2] === final[2],
  }

  if (coincide.periodo && coincide.mes && coincide.dia) return `${final[2]} de ${final[1]}, ${final[0]}`
  if (coincide.periodo && coincide.mes) return `Del ${inicial[2]} al ${final[2]} de ${final[1]}, ${final[0]}`
  if (coincide.periodo) return `Del ${inicial[2]} de ${inicial[1]} al ${final[2]} de ${final[1]}, ${final[0]}`
  return `Del ${inicial[2]} de ${inicial[1]} de ${inicial[0]} al ${final[2]} de ${final[1]}, ${final[0]}`
}

export class RecursoshumanosReportesIncapacidadesComponent {
  idEmpresa
  fechaInicial
  fechaFinal
  data = null
  exportando = false
  filtro = ''

  constructor ($location, $q, RecursoshumanosOperadorasService, RecursoshumanosReportesIncapacidadesService) {
    this.$location = $location
    this.$q = $q
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursoshumanosReportesIncapacidadesService = RecursoshumanosReportesIncapacidadesService
  }

  $onChanges (changes) {
    if (changes.fechaInicial && !isDate(this.fechaInicial)) {
      this.fechaInicial = moment().startOf('month').toDate()
    }

    if (changes.fechaFinal && !isDate(this.fechaFinal)) {
      this.fechaFinal = moment(this.fechaInicial).endOf('month').toDate()
    }
  }

  $onInit () {
    this.promise = this.$q.all([
      this.RecursoshumanosOperadorasService.get()
        .then((response) => (this.operadoras = orderBy(response.data, ['nombre']))),
      this.buscar(),
    ])
  }

  buscar () {
    if (!this.idEmpresa || !isDate(this.fechaInicial) || !isDate(this.fechaFinal)) return

    this.$location.search({
      id_empresa: this.idEmpresa,
      fecha_inicial: moment(this.fechaInicial).format('YYYY-MM-DD'),
      fecha_final: moment(this.fechaFinal).format('YYYY-MM-DD'),
    })

    return this.RecursoshumanosReportesIncapacidadesService.get(this.idEmpresa, this.fechaInicial, this.fechaFinal)
      .then((response) => {
        this.data = orderBy(response.data.sort((a, b) => b.fecha_inicial - a.fecha_inicial), ['proyecto', 'colaborador'])
        this.data.forEach((item) => {
          item.busqueda = `${normalizar(item.proyecto)}|${normalizar(item.colaborador)}|${item.tipo}`
          item.periodo = unificarPeriodo(item.fecha_inicial, item.fecha_final)
        })
        this.resultados = [...this.data]
      })
      .catch((e) => (console.error(e)))
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => item.busqueda.indexOf(filtro) >= 0)
  }

  exportar () {
    this.exportando = true
  }
}

module.component('recursoshumanosReportesIncapacidades', {
  controller: RecursoshumanosReportesIncapacidadesComponent,
  template,
  bindings: {
    idEmpresa: '<',
    fechaInicial: '<',
    fechaFinal: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/incapacidades/component.js